import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("4b86155b7b", "._7f9600d224140c59__control-wrapper{flex-grow:5}");
}
export default {"control-wrapper":"_7f9600d224140c59__control-wrapper"};
